var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_030---Croissant",
    "data-name": "030---Croissant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M50.36,26.49a1.46,1.46,0,0,0-.53-1.84,11.15,11.15,0,0,0-3.73-1.47,4.67,4.67,0,0,0-1.79-1.87c-2.26-1.43-6.16-2.81-12-1.42A6.48,6.48,0,0,0,25,18.5c-2.64,1-5.64,3.64-7.59,5.7-1.24,1.3-2,2.18-1.61,3.89a15,15,0,0,0-1.32,4.58,12.57,12.57,0,0,0,4.11,11c1.42,3.08,4.87,4.2,8.27,4.2a18.45,18.45,0,0,0,2-.14,3,3,0,0,0,.67.2c2.22.34,6.94-.21,7.37-2.47.21-1.16-.67-2.38-2.68-3.74a4.54,4.54,0,0,0-1-3.18,2.63,2.63,0,0,0,.93-1.23,3.11,3.11,0,0,0,2.39-1.8c2,.57,3.61.34,4.51-1.54a8,8,0,0,0,5.61-.47,7,7,0,0,0,5.79.53c3.13-1.25.65-5.47-2-7.53ZM15.79,32.9A14.07,14.07,0,0,1,17,28.68a9.73,9.73,0,0,1,7.68-.45c4.91,1.86,7.75,7.57,8.22,8.57a1.47,1.47,0,0,1-.7.83,21.17,21.17,0,0,0-5-2.22C21.84,33.62,17.88,36.87,18,41A10.92,10.92,0,0,1,15.79,32.9ZM26.56,46.55c-1.6,0-5.46-.43-6.81-3.54-1.79-4.13,1.73-8.13,7.05-6.35a22.93,22.93,0,0,1,4.25,1.79,3.1,3.1,0,0,1,1.79,2.45,2.64,2.64,0,0,0-1.62-.12,5.52,5.52,0,0,0-3.76,3.7,2.55,2.55,0,0,0,.15,2,9.21,9.21,0,0,1-1.05,0Zm9-1.34c-.08.42-.86,1-2.8,1.32a10.33,10.33,0,0,1-3.09.1,1.32,1.32,0,0,1-.9-.62,1.27,1.27,0,0,1-.11-1.09,4.18,4.18,0,0,1,2.87-2.87,1.26,1.26,0,0,1,1,.16c3,1.79,3.1,2.75,3.05,3ZM34,36c-2.41-5-6.89-9.68-12.5-9.68a11.93,11.93,0,0,0-4.45.92c0-.66.49-1.21,1.21-2,4.67-4.89,10.4-8.9,14.14-3.29,3.43,5.14,4.9,13.45,1.6,14Zm3-1.73c.84-3.9-1.23-9.83-3.64-13.25,5-1.05,8.35.15,10.32,1.4a3.77,3.77,0,0,1,1.14,1,7.92,7.92,0,0,0-4,5.93,19.87,19.87,0,0,1-.73,3.49c-.49,1.39-1.19,1.93-3.13,1.39Zm4.54-1.54a24.12,24.12,0,0,0,.6-3.16,6.71,6.71,0,0,1,3.64-5.14,9.68,9.68,0,0,1,3.4,1.32c.11.07.12.23,0,.33a6.59,6.59,0,0,0-2.34,3.16,8.92,8.92,0,0,0-.87,3.15,6.63,6.63,0,0,1-4.39.34Zm10.45.07a5.81,5.81,0,0,1-4.76-.5,9.26,9.26,0,0,1,.77-2.58,5.74,5.74,0,0,1,1.51-2.28c1.55,1.1,3.23,3.32,3.12,4.59a.84.84,0,0,1-.64.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-2",
    d: "M29.1,20.79A4.48,4.48,0,0,0,26,21,14.45,14.45,0,0,0,22.61,23l-.39.31-.66.55a.65.65,0,0,0,.85,1l.62-.52.38-.29a12.9,12.9,0,0,1,3-1.87,3.15,3.15,0,0,1,2.2-.16.66.66,0,1,0,.47-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-2",
    d: "M48.31,35.38a2.3,2.3,0,1,0,2.29,2.29A2.3,2.3,0,0,0,48.31,35.38Zm0,3.28a1,1,0,1,1,1-1A1,1,0,0,1,48.31,38.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-2",
    cx: 44.05,
    cy: 36.69,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    className: "cls-2",
    cx: 41.42,
    cy: 37.35,
    r: 0.66
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.28745fea6d89b236f8c5601e021c5189.svg";
export { ForwardRef as ReactComponent };